import React from 'react'

import NewProjectFormProto, {NewProjectFormProtoProps} from "../new-project-form-proto"
import {ProjectSystemType} from "../../../../../../core/model2/project/types"
import {newProject_getFormFieldsProto} from "../common"
import FormManager from "../../../../../../core/gd-form/common/form-manager"
import Form from '../../../../../../core/gd-form/form/form-add/form-add'

type Props = {
    template: any
} & NewProjectFormProtoProps

export default class GroupFromLocalTemplate extends NewProjectFormProto {

    constructor(props: Props) {
        super(props,  ProjectSystemType.CATEGORY)

        // FORM
        const initFormData = {
            company             : gd.companyId,
            parentProject       : this.initProjectId,
            name                : '',

            color               : this.defaultColor,
        }

        const formStructure = {
            fields      : newProject_getFormFieldsProto(this),
            onSubmit    : this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData)
    }

    onSubmit = async (result: any) => {
        const newProjectData = {

            toCompanyId         : result.company,
            toProjectId         : result.parentProject,

            templateId          : this.props.template.id,
            wipeTemplateContent : false,
            name                : result.name,

            color               : result.color,
        }

        const data = await gd.api.Project.newProjectFromTemplate(newProjectData).promise()

        this.onProjectCreated(data, ()=>{
            /*do nothing*/
        })
    }

    render() {
        return (
            <Form form={this.form} submitBtnClass="grey">
                <div className="tbl">
                    {this.renderSelectParent()}
                    {this.renderNameAndColor()}
                </div>
            </Form>
        )
    }
}
